










































import { Component, Mixins } from 'vue-property-decorator';
import { Mutations } from '@/ts/store/Constants';
import UserInquiryType from '@/ts/UserInquiryType';
import LocalizationMethods from '@/mixins/LocalizationMethods.vue';

@Component
export default class TypesView extends Mixins(LocalizationMethods) {
    constructor() {
        super();
    }

    get types(): UserInquiryType[] {
        return this.$store.getters['UserTicketsAttributes/getInquiryTypes'];
    }

    public changeView(type: UserInquiryType) {
        this.$store.commit(Mutations.SET_ACTIVE_HOME_ASSISTANT_TYPE, type);
        this.$store.commit(Mutations.SET_HOME_ASSISTANT_CURRENT_VIEW, 'CategoriesView');
    }

    public goToBookings() {
        this.$store.commit(Mutations.SET_HOME_ASSISTANT_VISIBILITY, false);

        if (this.$router.currentRoute.name !== 'shared-facilities') {
            this.$router.push({ name: 'shared-facilities' });
        }
    }
}
